import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isWebDesignDropdownOpen, setIsWebDesignDropdownOpen] = useState(false);
  const [isSEODropdownOpen, setIsSEODropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Web Design', path: '/web-design-el-paso' },
    { name: 'SEO', path: '/el-paso-seo' },
    { name: 'Local SEO', path: '/local-search-engine-optimization' },
    { name: 'Turnkey Websites', path: '/turnkey-websites' },
    { name: 'Social Media', path: '/social-media-marketing-el-paso' },
  ];

  const handleWebDesignMouseEnter = () => {
    setIsWebDesignDropdownOpen(true);
  };

  const handleWebDesignMouseLeave = () => {
    setTimeout(() => {
      setIsWebDesignDropdownOpen(false);
    }, 200);
  };

  const handleSEOMouseEnter = () => {
    setIsSEODropdownOpen(true);
  };

  const handleSEOMouseLeave = () => {
    setTimeout(() => {
      setIsSEODropdownOpen(false);
    }, 200);
  };

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className="w-10 h-10 bg-gradient-to-br from-purple-600 to-indigo-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl">D</span>
            </div>
            <span className={`font-bold text-xl font-['Poppins'] ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              David's Web Design
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={`font-medium hover:text-purple-600 transition-colors cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Home
            </Link>
            
            <div 
              className="relative"
              onMouseEnter={handleWebDesignMouseEnter}
              onMouseLeave={handleWebDesignMouseLeave}
            >
              <Link to="/web-design-el-paso" className={`font-medium hover:text-purple-600 transition-colors cursor-pointer flex items-center gap-1 ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
                Web Design
                <i className="ri-arrow-down-s-line text-sm"></i>
              </Link>
              
              {isWebDesignDropdownOpen && (
                <div 
                  className="absolute top-full left-0 mt-0 bg-white shadow-lg rounded-lg py-2 min-w-[240px]"
                  onMouseEnter={handleWebDesignMouseEnter}
                  onMouseLeave={handleWebDesignMouseLeave}
                >
                  <Link 
                    to="/seo-el-paso/get-small-business-website" 
                    className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-purple-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Get A Small Business Website
                  </Link>
                </div>
              )}
            </div>

            <div 
              className="relative"
              onMouseEnter={handleSEOMouseEnter}
              onMouseLeave={handleSEOMouseLeave}
            >
              <Link to="/el-paso-seo" className={`font-medium hover:text-purple-600 transition-colors cursor-pointer flex items-center gap-1 ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
                SEO Services
                <i className="ri-arrow-down-s-line text-sm"></i>
              </Link>
              
              {isSEODropdownOpen && (
                <div 
                  className="absolute top-full left-0 mt-0 bg-white shadow-lg rounded-lg py-2 min-w-[240px]"
                  onMouseEnter={handleSEOMouseEnter}
                  onMouseLeave={handleSEOMouseLeave}
                >
                  <Link 
                    to="/el-paso-seo-experts" 
                    className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-purple-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    El Paso SEO Experts
                  </Link>
                  <Link 
                    to="/local-search-engine-optimization" 
                    className="block px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-purple-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Local SEO Services
                  </Link>
                </div>
              )}
            </div>

            <Link to="/social-media-marketing-el-paso" className={`font-medium hover:text-purple-600 transition-colors cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Social Media
            </Link>
            <Link to="/turnkey-websites" className={`font-medium hover:text-purple-600 transition-colors cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Turnkey Websites
            </Link>
            <Link to="/blog" className={`font-medium hover:text-purple-600 transition-colors cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Blog
            </Link>
            <a href="#contact" className={`font-medium hover:text-purple-600 transition-colors cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Contact
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 bg-white md:hidden" style={{ top: '72px' }}>
          <div className="flex flex-col p-6 space-y-4">
            <Link 
              to="/" 
              className="text-gray-700 font-medium text-lg hover:text-purple-600 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Home
            </Link>
            <Link 
              to="/web-design-el-paso" 
              className="text-gray-700 font-medium text-lg hover:text-purple-600 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Web Design
            </Link>
            <Link 
              to="/seo-el-paso/get-small-business-website" 
              className="text-gray-700 font-medium text-base hover:text-purple-600 transition-colors cursor-pointer pl-4"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Get A Small Business Website
            </Link>
            <Link 
              to="/el-paso-seo" 
              className="text-gray-700 font-medium text-lg hover:text-purple-600 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              SEO Services
            </Link>
            <Link 
              to="/el-paso-seo-experts" 
              className="text-gray-700 font-medium text-base hover:text-purple-600 transition-colors cursor-pointer pl-4"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              El Paso SEO Experts
            </Link>
            <Link 
              to="/local-search-engine-optimization" 
              className="text-gray-700 font-medium text-base hover:text-purple-600 transition-colors cursor-pointer pl-4"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Local SEO Services
            </Link>
            <Link 
              to="/social-media-marketing-el-paso" 
              className="text-gray-700 font-medium text-lg hover:text-purple-600 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Social Media
            </Link>
            <Link 
              to="/turnkey-websites" 
              className="text-gray-700 font-medium text-lg hover:text-purple-600 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Turnkey Websites
            </Link>
            <Link 
              to="/blog" 
              className="text-gray-700 font-medium text-lg hover:text-purple-600 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Blog
            </Link>
            <a 
              href="#contact" 
              className="text-gray-700 font-medium text-lg hover:text-purple-600 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Contact
            </a>
          </div>
        </div>
      )}
    </>
  );
}
